export enum DashboardCaseStatusEnum {
  MY_OPEN_CASES = 'MyOpenCases',
  MY_NEXT_ACTIONS = 'MyNextActions',
  MY_OWNED_CASES = 'MyOwnedCases',
  ESCALATED_CASES = 'EscalatedCases',
  ALL_CASES = 'AllCases',
}
